export const BOT_UA_PATTERNS: readonly RegExp[] = [
    /bot/i, /crawl/i, /spider/i, /slurp/i, /mediapartners/i,
    /facebookexternalhit/i, /bingpreview/i, /googlebot/i,
    /yandex/i, /baidu/i, /duckduckbot/i, /semrush/i, /ahref/i,
    /lighthouse/i, /pagespeed/i, /headlesschrome/i, /phantomjs/i,
    /prerender/i, /snap\s?url/i, /archiver/i, /wget/i, /curl/i,
    // Social/messaging link-preview fetchers whose UA lacks "bot"
    // (Twitterbot/LinkedInBot/Slackbot/Discordbot already match /bot/).
    /whatsapp/i, /telegram/i, /slack/i, /embedly/i, /iframely/i,
    /skypeuripreview/i, /vkshare/i, /pinterest/i,
];

/**
 * Returns true if the given User-Agent string belongs to a known bot/crawler.
 * Pure function — no dependency on browser globals.
 */
export function isBotUserAgent(ua: string): boolean {
    if (!ua || ua.length < 10) return true;
    return BOT_UA_PATTERNS.some((re) => re.test(ua));
}
